import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import ListDoctorantCandidacies from "./List";
import ShowDoctorantCandidacy from "./Show";

export const resources = {
  isMenu: true,
  icon: <PersonSearchIcon />,
  name: `${DoctoralServicePath}doctorant-candidacies`,
  title: "Кандидати",
  list: <ListDoctorantCandidacies />,
  show: <ShowDoctorantCandidacy />,
  permission: permissions.canPreviewDoctorantCandidacies,
};
